import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17087653"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = { class: "profile__content" }
const _hoisted_3 = { class: "main-info" }
const _hoisted_4 = { class: "main-info__full-name" }
const _hoisted_5 = { class: "main-info__full-name--ru" }
const _hoisted_6 = { class: "main-info__full-name--bold" }
const _hoisted_7 = { class: "main-info__full-name--eng" }
const _hoisted_8 = { class: "main-info__zodiac" }
const _hoisted_9 = { class: "additional-info" }
const _hoisted_10 = { class: "additional-info__gender" }
const _hoisted_11 = { class: "additional-info__age" }
const _hoisted_12 = { class: "additional-info__birthday" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "motmom-profile-info" }, [
  /*#__PURE__*/_createTextVNode(" Для изменения персональных данных перейдите в "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://accounts.motmom.com/edit/general" }, " профиль Мотмом ")
], -1))
const _hoisted_14 = { class: "profile__image" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BirthdayField = _resolveComponent("BirthdayField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.moBaseUser.lastName) + ",", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.moBaseUser.firstName) + " " + _toDisplayString(_ctx.moBaseUser.middleName), 1)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.transliterate(_ctx.moBaseUser.lastName)) + ", " + _toDisplayString(_ctx.transliterate(_ctx.moBaseUser.firstName, _ctx.moBaseUser.middleName)), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_BirthdayField, {
            birthday: _ctx.moBaseUser.birthday
          }, null, 8, ["birthday"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.userGender), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.userAge) + " " + _toDisplayString(_ctx.pluralize(_ctx.userAge, ['год', 'года', 'лет'])), 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formattedDate), 1)
      ]),
      _hoisted_13
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("img", {
        src: _ctx.moBaseUser.avatarBigUrl,
        alt: "none"
      }, null, 8, _hoisted_15)
    ])
  ]))
}